import React from 'react';

import CarStatusTitle from '../items/static/carStatusTitle'
import getDates from './date.service'

const getRouteTableDataRows = (data, styles) => {
  let tableHeaders = [
    {
      className: styles.routeTime,
      title: "Дата и время"
    },
    {
      className: styles.routeState,
      title: "Статус ТС"
    },
    {
      className: styles.routeInformation,
      title: "Данные маршрута",
    },
    {
      className: styles.routeAddress,
      title: "Адрес"
    }
  ]
  let tableContent = []

  data.forEach((item, index) => {
    let lastItem = data[index - 1]

    if (!!lastItem && isDatesUnequal(lastItem.date, item.date)) {
      tableContent.push({
        className: 'tableRowDate',
        items: [
          {
            data: <span>{getDates.getDateFormat1(item.date)}</span>
          }
        ]
      })
    }

    let row = {
      index: item.index,
      className: 'tableRowData',
      activeClassName: 'tableRowData_active',
      isActive: item.isActive,
      date: item.date,
      items: [
        {
          className: styles.routeTime,
          data: <span>{getDates.getTimeFormat1(item.date)}</span>
        },
        {
          className: styles.routeState,
          data: <CarStatusTitle status={item.status} />
        },
        {
          className: styles.routeInformation,
          data: <span>
            {
              item.status === 0
                ? `С ${getDates.getTimeFormat2(item.information)}`
                : item.status === 1
                  ? getInMoveInformation(item.information)
                  : getParkingInformation(item.information)
            }
          </span>
        },
        {
          className: styles.routeAddress,
          data: <span> {item.address}</span>
        }
      ]
    }

    tableContent.push(row)
  })

  tableContent.unshift({
    className: 'tableRowDate',
    items: [
      {
        data: <span>{getDates.getDateFormat1(data[0].date)}</span>
      }
    ]
  })

  return {
    tableHeaders,
    tableContent
  }
}

const getInMoveInformation = (num) => {
  let number = Number(num) > 1000 ? Number(num) / 1000 : Number(num)
  return Number(num) > 1000 ? number.toFixed(3) + ' км.' : number + ' м.'
}

const getParkingInformation = (data) => {
  const h = Math.floor(data / 3600)
  const m = Math.floor((data - h * 3600) / 60)
  const s = data - h * 3600 - m * 60
  return lessTen(h) + ':' + lessTen(m) + ':' + lessTen(s)
}

const lessTen = (n) => {
  return n < 10 ? '0' + n : n
}

const isDatesUnequal = (prev, current) => {
  let prevDate = getDates.getNullTimeDateUtcNumber(new Date(prev))
  let currentDate = getDates.getNullTimeDateUtcNumber(new Date(current))

  return prevDate !== currentDate
}

const getRouteTableData = (page, rowsOnPage, data, styles) => {
  let start = page * rowsOnPage - rowsOnPage
  let finish = page * rowsOnPage
  let pageData = data.slice(start, finish)

  return getRouteTableDataRows(pageData, styles)
}

export default getRouteTableData